import { Table } from "antd";
import { Component } from "react";

import { BTModal } from "commonComponents/btWrappers/BTModal/BTModal";
import { BTModalLayout } from "commonComponents/btWrappers/BTModal/BTModalLayout";
import { BTTable } from "commonComponents/btWrappers/BTTable/BTTable";
import { PageSection } from "commonComponents/utilities/PageSection/PageSection";

import { type CostCodeConflict } from "entity/costCode/CostCodeDetails/CostCode.api.types";

interface ICostCodeConflictProps {
    onClose: () => void;
    conflictList?: CostCodeConflict[];
}

export class CostCodeConflictModal extends Component<ICostCodeConflictProps> {
    render() {
        return (
            <BTModal
                data-testid="btModalCostCodeConflict"
                beforeClose={this.props.onClose}
                visible={true}
                removeBodyPadding={true}
                width="600px"
                title="Cost Code"
                useModalLayout
            >
                <BTModalLayout
                    title="Cost Code"
                    modalConfig={{ beforeClose: this.props.onClose, parentRoute: "" }}
                >
                    <PageSection>
                        <BTTable dataSource={this.props.conflictList} pagination={false} sticky>
                            <Table.Column<CostCodeConflict>
                                title="Jobsite"
                                dataIndex="jobsiteName"
                            />
                            <Table.Column<CostCodeConflict> title="Type" dataIndex="type" />
                            <Table.Column<CostCodeConflict> title="Title" dataIndex="title" />
                        </BTTable>
                    </PageSection>
                </BTModalLayout>
            </BTModal>
        );
    }
}
